<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <div class="row">
          <div class="col-md-6">
            <h4 class="text-bold" v-if="!this.$route.params.embroidery">
              Thread Colors
            </h4>
            <h4 class="text-bold" v-if="this.$route.params.embroidery">
              Embroidery Thread Colors
            </h4>
          </div>
          <div class="col-md-6 text-right">
            <toggle-button v-model="choosableOnly" /> Choosable only
          </div>
        </div>
      </div>
      <div class="grid-body">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="sort" @click="sort('id')">#ID</th>
              <th class="sort" @click="sort('title_en')">Title (English)</th>
              <th class="sort" @click="sort('title_th')">Title (Thai)</th>
              <th class="sort" @click="sort('title_de')">Title (German)</th>
              <th class="sort" @click="sort('title_translatable')">
                Title (Translatable)
              </th>
              <th class="sort" @click="sort('hex_code')">Hex Code</th>
              <th class="sort" @click="sort('internal_number')">
                Internal Number (Thai)
              </th>
              <th class="sort" @click="sort('fabrics')">Fabrics</th>
              <th class="sort text-center" @click="sort('chooseable')">
                Chooseable
              </th>
              <th class="sort text-center" @click="sort('order_color')">
                Order
              </th>
              <th class="text-right">
                <button
                  class="btn btn-success"
                  @click="showCreateDialog()"
                  v-if="!isReadOnlyUser"
                >
                  <i class="fa fa-plus-circle" aria-hidden="true"></i> New
                  Thread Color
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(color, index) in colors.filter((c) =>
                choosableOnly ? c.chooseable : true
              )"
              :key="index"
            >
              <td># {{ color.legacy_id }}</td>
              <td>{{ color.title_en }}</td>
              <td>{{ color.title_th }}</td>
              <td>{{ color.title_de }}</td>
              <td>{{ color.title_translatable }}</td>
              <td>{{ color.hex_code }}</td>
              <td>{{ color.internal_number }}</td>
              <td>
                <router-link
                  v-if="color.fabrics.length > 0"
                  class="badge badge-default"
                  :to="'/fabric/update/' + fabric"
                  :key="color.legacy_id + '_' + fabric"
                  v-for="fabric in color.fabrics"
                >
                  {{ $Fabric.getCode(fabric) }}
                </router-link>
              </td>
              <td class="text-center">
                <span class="badge badge-success" v-if="color.chooseable"
                  >YES</span
                >
                <span class="badge badge-danger" v-else>NO</span>
              </td>
              <td class="text-center">
                {{ color.order_color ? color.order_color : "-" }}
              </td>
              <td class="text-right">
                <button
                  class="btn btn-primary"
                  @click="showUpdateDialog(index)"
                  v-if="!isReadOnlyUser"
                >
                  <i class="fa fa-edit" aria-hidden="true"></i>
                  Edit
                </button>
                <button
                  class="btn btn-danger"
                  :disabled="color.order_color == 1"
                  @click="deleteColor(index)"
                  v-if="!isReadOnlyUser"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold" v-if="editId != null">
              Update Thread Color
            </h5>
            <h5 class="modal-title text-bold" v-else>New Thread Color</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group">
              <label>Title (English) </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.title_en"
                placeholder="Title (English)"
              />
              <small v-if="errors.title_en" class="form-text text-danger">{{
                errors.title_en.join(" ")
              }}</small>
            </div>

            <div class="form-group">
              <label>Title (Thai) </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.title_th"
                placeholder="Title (Thai)"
              />
              <small v-if="errors.title_th" class="form-text text-danger">{{
                errors.title_th.join(" ")
              }}</small>
            </div>

            <div class="form-group">
              <label>Title (German) </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.title_de"
                placeholder="Title (German)"
              />
              <small v-if="errors.title_de" class="form-text text-danger">{{
                errors.title_de.join(" ")
              }}</small>
            </div>

            <div class="form-group">
              <label>Title (Translatable) </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.title_translatable"
                placeholder="Title (Translatable)"
              />
              <small
                v-if="errors.title_translatable"
                class="form-text text-danger"
                >{{ errors.title_translatable.join(" ") }}</small
              >
            </div>

            <div class="form-group">
              <label>Hex Code </label>
              <div class="row">
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="formData.hex_code"
                    placeholder="#12DCFF"
                  />
                </div>
                <div class="col-md-2">
                  <v-input-colorpicker
                    v-model="formData.hex_code"
                    @input="handleInput"
                    @change="handleChange"
                    class="btn btn-block"
                  />
                </div>
              </div>
              <small v-if="errors.hex_code" class="form-text text-danger">{{
                errors.hex_code.join(" ")
              }}</small>
            </div>

            <div class="form-group">
              <label>Internal Number </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.internal_number"
                placeholder="1234"
              />
              <small
                v-if="errors.internal_number"
                class="form-text text-danger"
                >{{ errors.internal_number.join(" ") }}</small
              >
            </div>

            <div class="toggle">
              <label for="">Chooseable </label>
              <toggle-button
                @change="changeChooseable"
                :sync="true"
                v-model="formData.chooseable"
              />
              YES
            </div>

            <div
              class="form-group mt-2"
              v-if="formData.order_color !== 1 && formData.chooseable"
            >
              <label>Order</label>
              <div v-if="editId">
                <toggle-button
                  :sync="true"
                  v-model="changeThreadColorOrder"
                  :value="changeThreadColorOrder"
                />
                Change order
              </div>
              <div class="mt-2">
                <p-radio
                  class="p-default p-curve"
                  color="primary"
                  v-model="formData.thread_color_reference_location"
                  value="before"
                  :disabled="!changeThreadColorOrder"
                  >Before</p-radio
                >
                <p-radio
                  class="p-default p-curve"
                  color="primary"
                  v-model="formData.thread_color_reference_location"
                  value="after"
                  :disabled="!changeThreadColorOrder"
                  >After</p-radio
                >
              </div>
            </div>

            <div
              class="form-group"
              v-if="formData.order_color !== 1 && formData.chooseable"
            >
              <div>
                <v-select
                  :options="colorsChoosable"
                  v-model="formData.thread_color_reference_id"
                  label="title"
                  :disabled="!changeThreadColorOrder"
                  :reduce="(color) => color.id"
                  placeholder="Select a thread color"
                  :selectable="checkIsSelectable"
                >
                  <template v-slot:option="option">
                    <span :class="option.icon"></span>
                    [{{ option.order_color }}] - {{ option.title }}
                  </template>
                </v-select>
                <p v-if="editId && changeThreadColorOrder">
                  Current order {{ formData.order_color }}
                </p>
              </div>
              <small
                v-if="errors.thread_color_reference_id"
                class="form-text text-danger"
                >You must select the new color position.</small
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="editId != null"
              @click="updateColor()"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-else
              @click="createColor()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import InputColorPicker from "vue-native-color-picker";
export default {
  components: {
    "v-input-colorpicker": InputColorPicker,
  },
  data() {
    return {
      colors: [],
      colorsChoosable: [],
      formData: {},
      editId: null,
      sortType: "asc",
      embroidery_only: 0,
      choosableOnly: true,
      errors: {},
      changeThreadColorOrder: false,

      // color: '#59c7f9',
      suckerCanvas: null,
      suckerArea: [],
      isReadOnlyUser: false,
    };
  },
  watch: {
    $route: function () {
      this.embroidery_only = this.$route.params.embroidery ? 1 : 0;
      this.getThreadColors();
    },
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.embroidery_only = this.$route.params.embroidery ? 1 : 0;
    this.getThreadColors();
  },
  methods: {
    sort(column) {
      this.sortType = this.sortType === "asc" ? "desc" : "asc";
      this.colors = _.orderBy(
        this.colors,
        [
          (row) => {
            if (column === "fabrics") {
              let fabrics = row[column];
              if (fabrics.length > 0) {
                return fabrics[0];
              } else {
                return "";
              }
            } else {
              return row[column];
            }
          },
        ],
        [this.sortType]
      );
    },

    async getThreadColors() {
      try {
        let res = await axios.get("v2/fabrics/thread_colors", {
          params: { embroidery_only: this.embroidery_only },
        });
        this.colors = res.data.data;
        this.colorsChoosable = res.data.data
          .filter((color) => color.chooseable)
          .sort((a, b) =>
            (a.order_color || Infinity) > (b.order_color || Infinity) ? 1 : -1
          );

        this.sortType = "desc";
        this.sort("order_color");
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Unable to load thread colors");
        }
      }
    },

    showCreateDialog() {
      this.editId = null;
      this.changeThreadColorOrder = true;
      this.errors = {};
      this.formData = {
        chooseable: false,
        thread_color_reference_id: null,
        thread_color_reference_location: "after",
      };
      show_modal("#modal-box");
    },

    showUpdateDialog(index) {
      var data = this.colors[index];
      this.errors = {};
      this.formData = {
        title_en: data.title_en,
        title_th: data.title_th,
        title_de: data.title_de,
        title_translatable: data.title_translatable,
        hex_code: data.hex_code,
        internal_number: data.internal_number,
        chooseable: data.chooseable ? true : false,
        order_color: data.order_color,
        thread_color_reference_id: null,
        thread_color_reference_location: "after",
      };
      this.editId = data.id;
      this.changeThreadColorOrder = false;
      show_modal("#modal-box");
    },

    async createColor() {
      if (
        !this.formData.thread_color_reference_id &&
        this.formData.chooseable
      ) {
        this.errors = {
          thread_color_reference_id: "You must pick the color order.",
        };
        return;
      }

      this.formData.embroidery_only = this.embroidery_only;
      try {
        let res = await axios.post("v2/fabrics/thread_colors", {
          ...this.formData,
          thread_color_reference_location:
            this.formData.thread_color_reference_id === 1
              ? "after"
              : this.formData.thread_color_reference_location,
        });
        if (res) {
          this.getThreadColors();
          toastr.success("Success");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },

    async updateColor() {
      if (
        this.formData.chooseable &&
        this.formData.order_color == null &&
        !this.formData.thread_color_reference_id
      ) {
        this.errors = {
          thread_color_reference_id: "You must pick the color order.",
        };
        return;
      }

      if (
        !this.formData.thread_color_reference_id &&
        this.formData.chooseable &&
        this.changeThreadColorOrder
      ) {
        this.errors = {
          thread_color_reference_id: "You must pick the color order.",
        };
        return;
      }

      try {
        this.formData.embroidery_only = this.embroidery_only;
        if (!this.changeThreadColorOrder) {
          delete this.formData.thread_color_reference_id;
        }
        let res = await axios.put("v2/fabrics/thread_colors/" + this.editId, {
          ...this.formData,
          thread_color_reference_location:
            this.formData.thread_color_reference_id === 1
              ? "after"
              : this.formData.thread_color_reference_location,
        });
        if (res) {
          this.getThreadColors();
          toastr.success("Success");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },

    async deleteColor(index) {
      let result = await Swal.fire({
        title: "Are you sure to Delete?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });

      if (!result.value) {
        return;
      }
      try {
        let data = this.colors[index];
        let res = await axios.delete("v2/fabrics/thread_colors/" + data.id);
        if (res) {
          this.getThreadColors();
          toastr.success("SUCCESS");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "Unable to delete this thread color, contact the admins for help!"
          );
        }
      }
    },
    handleInput(hexCode) {
      // This method must be declared because it's required by the color picker library
    },
    handleChange(hexCode) {
      // This method must be declared because it's required by the color picker library
    },

    checkIsSelectable(option) {
      if (this.formData.thread_color_reference_location == "before") {
        return option.order_color !== 1
          ? option.order_color !== this.getMaxOrderNo()
          : false;
      }
      if (this.formData.thread_color_reference_location == "after") {
        if (option.order_color == this.formData.order_color) {
          return false;
        }
        if (option.order_color == this.formData.order_color - 1) {
          return false;
        }
        return true;
      }
    },

    changeChooseable(sel) {
      if (sel.value === false) {
        this.formData.thread_color_reference_id = null;
      }
    },

    getMaxOrderNo() {
      const el = this.colorsChoosable.reduce(function (prev, current) {
        return prev.order_color > current.order_color ? prev : current;
      });
      return el.order_color;
    },
  },
};
</script>


<style scoped>
.icp__input {
  border-radius: 4px;
  background-color: #000 !important;
}
.mt-2 {
  margin-top: 10px;
}
</style>
